/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  CheckContactRequestStatusQueryResponse,
  CheckContactRequestStatusQueryParams,
  CheckContactRequestStatus400,
  CheckContactRequestStatus404,
} from '../types/CheckContactRequestStatus'

function getCheckContactRequestStatusUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/contact_request/check-status/` as const,
  }
  return res
}

/**
 * @summary Poll contact-request progress for a campaign
 * {@link /api/v1/contact_request/check-status/}
 */
export async function checkContactRequestStatus(
  params: CheckContactRequestStatusQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    CheckContactRequestStatusQueryResponse,
    ResponseErrorConfig<
      CheckContactRequestStatus400 | CheckContactRequestStatus404
    >,
    unknown
  >({
    method: 'GET',
    url: getCheckContactRequestStatusUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
